import { defineStore } from 'pinia';
import { ref } from 'vue';
import { useLocalStorage } from '@vueuse/core';

// View preferences never enter the annotation snapshot or dirty/lease checks.
export const useDentalSceneStore = defineStore('dental-scene', () => {
  const enabled = ref(false);
  const referenceLinesVisible = useLocalStorage('labelz-mpr-reference-lines', true);
  const segmentationVisible = ref(true); const selectedOnly = ref(false);
  const segmentationOpacity = ref(0.72); const volumeVisible = ref(true);
  const landmarksVisible = ref(true); const landmarkLabels = ref(true); const landmarkRadius = ref(0.65);
  const meshVisible = ref(true); const meshOpacity = ref(0.9);
  const originalVisible = ref(false); const residualsVisible = ref(true);
  const surfaceBusy = ref(false); const surfaceCount = ref(0); const surfaceBuildMs = ref(0); const surfaceError = ref('');
  const surfaceCompleted = ref(0); const surfaceTotal = ref(0);
  return { enabled, referenceLinesVisible, segmentationVisible, selectedOnly, segmentationOpacity, volumeVisible,
    landmarksVisible, landmarkLabels, landmarkRadius, meshVisible, meshOpacity,
    originalVisible, residualsVisible, surfaceBusy, surfaceCount, surfaceBuildMs, surfaceError, surfaceCompleted, surfaceTotal };
});
